<template>
    <div>
        <AlertDismiss class="mx-2 mt-2" ref="alertDismiss"></AlertDismiss>

        <b-overlay :show="disabled">
            <b-table :busy="isBusy" :fields="fields" :items="filteredItems" small sticky-header="60vh" responsive
                no-border-collapse show-empty class="mb-0">
                <template #empty>
                    <b-card v-if="items === null" class="text-center my-2 fs-5">
                        Descargando información...
                    </b-card>
                    <b-card v-else-if="items.length !== 0" class="text-center my-2 fs-5">
                        No hay personas que coincidan con los criterios de búsqueda
                    </b-card>
                    <b-card v-else class="text-center my-2 fs-5">
                        Aún no se ha creado ninguna persona / empresa
                    </b-card>
                </template>

                <!--icono de carque de tabla-->
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando datos de tabla...</strong>
                    </div>
                </template>

                <template #cell(name)="data">
                    <div class="table-row" :draggable="!disabled" @dragstart="handleDragStart($event, data.item.id)">
                        {{ data.item.name }}
                    </div>
                </template>
            </b-table>
        </b-overlay>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums'
import {formatRut} from '@/plugins/complianceScripts'

export default {
    name: 'TableLegalEntity',

    components: {
        AlertDismiss
    },

    data() {
        return {
            isBusy: false,
            items: null,

            searchQuery: '',
            disabled: false,

            fields: [
                { key: 'name', label: 'Nombre' , thClass: 'col-8'},
                { key: 'type', label: 'Tipo'},
                { key: 'rut', label: 'RUT', formatter: formatRut},
            ]
        }
    },

    async mounted() {
        await this.getEntities();

        this.$eventBus.$on(EventNames.FilterLegalEntityAfterSearch, (query) => {
            this.processingTable();

            this.searchQuery = query

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.UpdateLegalEntities, () => {
            this.processingTable();

            this.getEntities();

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.StartProcessAddShareholder, async () => {
            this.disabled = true;
        });

        this.$eventBus.$on(EventNames.EndProcessAddShareholder, async () => {
            this.disabled = false;
        })

    },

    computed: {
        filteredItems() {
            if (this.searchQuery) {
                return this.filterForSearch(this.items, this.searchQuery)
            }

            return this.items;
        },
    },

    methods: {
        ...mapActions(["getAllEntities"]),

        processingTable() {
            this.isBusy = !this.isBusy
        },

        handleDragStart(event, id) {
            if (!this.disabled) {
                event.dataTransfer.setData('text/plain', id);
                this.$eventBus.$emit(EventNames.StartDragShareholder, id)
            }
        },

        formatType(str) {
            if (str ===  'company') {
                return 'Sociedad'
            } else if (str === 'managedCompany') {
                return 'Administrada'
            } else {
                return 'Persona'
            }
        },

        async getEntities() {
            this.items = []

            let result = await this.getAllEntities();

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.items = result.data
                .filter(item => item.type !== 'instance')
                .map(x => {
                    return {...x, type: this.formatType(x.type)}
                })
        },

        filterForSearch(entities, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            return entities.filter(item => {
                for (let key of ['name', 'rut', 'type']) {
                    if (item[key].toString().toLowerCase().includes(normalizedQuery)) {
                        return true;
                    }
                }

                return false;
            });
        },

        getRowDragClass(data) {
            if (this.disabled) {
                return '';
            }

            if (data.item.type === 'instance') {
                return 'drag-item-instance';
            }

            return 'drag-item';
        }
    },
}
</script>

<style scoped>
.table-row {
    cursor: grab;
}
</style>
